// enums
export const FOLDER = "FOLDER";
export const TOTAL_SIZE = "TOTAL_SIZE";
export const DOWNLOAD_ALL_MY_FILES = "DOWNLOAD_ALL_MY_FILES";
export const FILE = "FILE";
export const COMPANY_DOCS_SIZE = "COMPANY_DOCS_SIZE";

// types
export interface DocumentFile {
	clean: boolean;
	company: string;
	content_type?: string;
	filename: string;
	id: string;
	length: number;
	owner: string;
	pending?: boolean;
	tags: string[];
	uploader: string;
	vis_to_emp?: boolean;
	vis_to_man?: boolean;
	vis_to_everyone?: boolean;
	signers?: string[];
	_id: string;
	uploadedAt: string;
	allow_ai_retrieval?: boolean;
	/** Active embedding task ID if document is currently being processed for AI retrieval */
	embedding_task_id?: string;
	/** True if the most recent embedding task failed */
	embedding_failed?: boolean;
	/** Error type from the most recent failed embedding task (e.g. "PDFValidationError-size") */
	embedding_error_type?: string;
}

export interface DocumentsData {
	myFiles: DocumentFile[];
	companyFiles: DocumentFile[];
	signedFiles: DocumentFile[];
	companyMaxSpace: number;
	companyTotalFilesSize: number;
}

export interface EditDocumentParams {
	id: string;
	fileName: string;
	vis_to_emp?: boolean;
	vis_to_man?: boolean;
	vis_to_everyone?: boolean;
	tags?: string[];
	allow_ai_retrieval?: boolean;
}

export interface UserData {
	employeeID: string;
	employeeName: string;
	thisUserId: string;
	userIsAdmin: boolean;
}

export interface FolderState {
	companyDocumentsOpen: boolean;
	signedDocumentsOpen: boolean;
	myDocumentsOpen: boolean;
}
